export enum TransactionTypeCategory {
	SchoolSupplies = 'School Supplies',
	Achievement = 'Achievement',
	JobIncome = 'Job Income',
	SavingsDeposit = 'Savings Deposit',
	SchoolServices = 'School Services',
	Refund = 'Refund',
	Adjustment = 'Adjustment',
	Deposit = 'Deposit',
	SavingsTransfer = 'SavingsTransfer',
	TransferSavings = 'TransferSavings'
}

export enum TransactionTypeName {
	SchoolStorePurchase = 'School store purchase',
	TeacherAwardedPoints = 'Teacher awarded points',
	IncomeFromJobAssignment = 'Income from Job Assignment',
	DepositToSavings = 'Deposit to Savings',
	DiscretionaryAllowance = 'Discretionary allowance (e.g. lunch pass)',
	RefundFromSchoolStore = 'Refund from school store',
	ChangeInPoints = 'Change in Points',
	InitialDeposit = 'Coupon Redemption',
	TransferToSavings = 'Transfer to Savings',
	TransferFromSavings = 'Transfer from Savings'
}
